// extracted by mini-css-extract-plugin
export default {"settingsWrapper":"AccountSettings_settingsWrapper__3WyYU","settingsInfo":"AccountSettings_settingsInfo__1CGeJ"};